import React from "react";

const PortfolioHero = () => {
    return (
        <section className="bg-gradient-to-b max-w-6xl mx-auto from-[#FAFBFF] to-white pt-10 px-4">
            {/* Badge */}
            <div className="text-center mb-4 mt-8">
                <span className="text-sm text-primary uppercase text-green-700 font-semibold px-4 py-1 rounded-full">
                    See What We’ve Built
                </span>
            </div>

            {/* Main Heading */}
            <h1 className="text-3xl md:text-4xl font-extrabold !leading-snug text-center text-[#0A033C] mb-4">
                From concept to launch — a showcase of our successful product journeys.

            </h1>

            {/* Subheading */}
            <p className="text-center text-[#6B7280] text-md mb-10">
                Results that make an impact
            </p>


        </section>
    );
};

export default PortfolioHero;
